export default __webpack_public_path__ + "static/orumlabs-1afa3fa58a67926e58c819756f362b3d.png";